module.exports = __webpack_public_path__ + "img/sprinkle-16.fa0c80ed.jpg";